"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CreateSupplier = /** @class */ (function () {
    function CreateSupplier() {
        this.id = null;
        this.name = '';
        this.description = null;
        this.email = null;
        this.address = null;
        this.phone = null;
    }
    CreateSupplier.prototype.setName = function (name) {
        this.name = name;
    };
    CreateSupplier.prototype.setDescription = function (description) {
        this.description = description || null;
    };
    CreateSupplier.prototype.setEmail = function (email) {
        this.email = email || null;
    };
    CreateSupplier.prototype.setAddress = function (address) {
        this.address = address || null;
    };
    CreateSupplier.prototype.setPhone = function (phone) {
        this.phone = phone || null;
    };
    __decorate([
        mobx_1.observable
    ], CreateSupplier.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], CreateSupplier.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], CreateSupplier.prototype, "description", void 0);
    __decorate([
        mobx_1.observable
    ], CreateSupplier.prototype, "email", void 0);
    __decorate([
        mobx_1.observable
    ], CreateSupplier.prototype, "address", void 0);
    __decorate([
        mobx_1.observable
    ], CreateSupplier.prototype, "phone", void 0);
    __decorate([
        mobx_1.action
    ], CreateSupplier.prototype, "setName", null);
    __decorate([
        mobx_1.action
    ], CreateSupplier.prototype, "setDescription", null);
    __decorate([
        mobx_1.action
    ], CreateSupplier.prototype, "setEmail", null);
    __decorate([
        mobx_1.action
    ], CreateSupplier.prototype, "setAddress", null);
    __decorate([
        mobx_1.action
    ], CreateSupplier.prototype, "setPhone", null);
    return CreateSupplier;
}());
exports.CreateSupplier = CreateSupplier;
var Supplier = /** @class */ (function (_super) {
    __extends(Supplier, _super);
    function Supplier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Supplier;
}(CreateSupplier));
exports.Supplier = Supplier;
//# sourceMappingURL=Supplier.js.map